import { useEffect, useState } from "react";
import { arabicFontSettingsStore } from "../../stores/sessionStore";

const ArabicFontSettings=()=>{
    const [currentFont,setCurrentFont]=useState(null);
    const [currentFontSize,setCurrentFontSize]=useState(null);
    const [currentFontClasses,setCurrentFontClasses]=useState(null);
    
    const arbFontArr=['Amiri','IndoPak','Katibeh','Lateef','Me Quran','Quran Majeed','Rakkas','Scheherazade','Uthmanic','PDMS Saleem'];

    const getFontClass=(fontId)=>{
        let fontName;
        switch(fontId){
            case '1':fontName='font-Amiri';break;
            case '2':fontName='font-MushafFont';break;
            case '3':fontName='font-KatibehFont';break;
            case '4':fontName='font-LateefFont';break;
            case '5':fontName='font-meQuranFont';break;
            case '6':fontName='font-QuranMajeedFont';break;
            case '7':fontName='font-RakkasFont';break;
            case '8':fontName='font-ScheherazadeFont';break;
            case '9':fontName='font-UthmanicFont';break;
            case '10':fontName='font-PDMSSaleemFont';break;
            default:break;
        }
        return fontName;
    }

    const getFontSizeClass=(fSize)=>{
        let fontSize;
        switch(fSize){
            case '1':fontSize='fontSize-one';break;
            case '2':fontSize='fontSize-two';break;
            case '3':fontSize='fontSize-three';break;
            case '4':fontSize='fontSize-four';break;
            case '5':fontSize='fontSize-five';break;
            default:break;
        }
        return fontSize;
    }

    const handleArabicFont=(fontId)=>{
        const fontName=getFontClass(fontId);
        let fontSettingsData=JSON.parse(localStorage.getItem('fontSettings'));

        // Select all elements with the 'arabic-text' class
        document.querySelectorAll('.arabic-text').forEach((element) => {
            removeClassByPrefix(element, 'font-'); // Remove classes with 'font-' prefix
            element.classList.add(fontName); // Add the new font class
        });

        // Select all elements with the 'mushaf-arb-text' class
        document.querySelectorAll('.mushaf-arb-text').forEach((element) => {
            removeClassByPrefix(element, 'font-'); // Remove classes with 'font-' prefix
            element.classList.add(fontName); // Add the new font class
        });

        fontSettingsData.arabicFont=fontId;
        localStorage.setItem('fontSettings',JSON.stringify(fontSettingsData));
        refreshTafsirFrame();
        setCurrentFont(fontId);
    }

    const handleArabicFontSize=(event)=>{
        const fSize=event.target.value;
        let fontSettingsData=JSON.parse(localStorage.getItem('fontSettings'));
        const fontSize=getFontSizeClass(fSize)

        // Update elements with the 'arabic-text' class
        document.querySelectorAll('.arabic-text').forEach((element) => {
            element.classList.remove('text-4xl'); // Remove 'text-4xl' class
            removeClassByPrefix(element, 'fontSize-'); // Remove classes with 'fontSize-' prefix
            element.classList.add(fontSize); // Add the new font size class
        });

        // Update elements with the 'mushaf-arb-text' class
        document.querySelectorAll('.mushaf-arb-text').forEach((element) => {
            element.classList.remove('text-4xl'); // Remove 'text-4xl' class
            removeClassByPrefix(element, 'fontSize-'); // Remove classes with 'fontSize-' prefix
            element.classList.add(fontSize); // Add the new font size class
        });

        fontSettingsData.arabicFontSize=fSize;
        localStorage.setItem('fontSettings',JSON.stringify(fontSettingsData));
        refreshTafsirFrame();
        setCurrentFontSize(event.target.value);
    }

    useEffect(()=>{
        if(currentFont!==null&&currentFontSize!==null)
        {
            const fontClass = getFontClass(currentFont);
            const fontSizeClass = getFontSizeClass(currentFontSize);
            setCurrentFontClasses({ fontClass, fontSizeClass });
            arabicFontSettingsStore.set({ fontClass, fontSizeClass });
        }
    },[currentFont,currentFontSize]);

    useEffect(()=>{
        const fontSettings=JSON.parse(localStorage.getItem("fontSettings"));
        if(fontSettings!==null)
        {
            setCurrentFont(fontSettings.arabicFont);
            setCurrentFontSize(fontSettings.arabicFontSize);
        }
    },[]);

    return(
        <div className="pb-16 flex flex-col">
            <div className="flex justify-end text-style-preview">
                <p className={`text-white mt-[25px] mb-[15px] ${currentFontClasses?`${currentFontClasses.fontClass} ${currentFontClasses.fontSizeClass}`:``}`}>سُبْحَانَ ٱللَّٰهِ</p>
            </div>
            <div className="overflow-auto overflow-y-auto font-settings-pane">
                <h4 className="text-white mb-6">Arabic font</h4>
                {
                    arbFontArr.map((font,fontIndex)=>{
                        const fontId=fontIndex+1;
                        return (
                            <div key={fontId} className="flex items-center ml-2 mb-4">
                                <input id={`arabicFont-react-${fontId}`} type="radio" value="" name="arabicFontRadioReact" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300" onChange={()=>{handleArabicFont(fontId.toString())}} checked={fontId.toString()===currentFont}/>
                                <label htmlFor={`arabicFont-react-${fontId}`} className="ml-2 text-sm font-medium text-white">{font}</label>
                            </div>
                        );
                    })
                }

                <h4 className="text-white mt-10 mb-6">Arabic font size</h4>
                <label htmlFor="arabic-font-size-react" className="block mb-2 text-sm font-medium text-white">Font size</label>
                <input id="arabic-font-size-react" type="range" min="3" max="5" step="1" className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700 mb-[120px]" onChange={handleArabicFontSize} value={currentFontSize?currentFontSize:"5"}/>
            </div>
        </div>
    )
}

export default ArabicFontSettings;